export default "__VITE_ASSET__CjUMzgdN__"